export const imagePreloader = (imageUrls) => {
    const promises = imageUrls.map((url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = `https://online-escaperoom.de/${url}`;
            img.addEventListener("load", resolve);
            img.onerror = reject;
        });
    });
    return Promise.all(promises);
};
